import { LoadingOutlined } from '@ant-design/icons';
import { Card, Col, Popover, Row, Spin } from 'antd';
import React, { ReactElement } from 'react';
import { useSmoothScroll } from '../../../../../../../shared/hooks/useSmoothScroll';
import { ReactComponent as TickIcon } from '../../../../../../../assets/images/svg/green-tick-icon.svg';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../../store';
import { Payer } from '../../../../../../../shared/models/payer.model';

const PolicyCard = ({ policySearchResults, isSelected, index, loading, disabled, isConfirmed }: any): ReactElement => {
  useSmoothScroll('scroll-policy');
  const {
    productName, memberId, productId, payerName, payerId,
  } = policySearchResults;
  const configuredPayers = useSelector((state: RootState): Payer[] => state.payerList.allPayers);

  const getPayerIcon = (payerID: number): string | undefined => {
    const payerDetail = configuredPayers?.find(
      ({ id }: Payer): boolean => id === payerID,
    );
    return payerDetail?.payerIcon;
  };
  const payerIconUrl = getPayerIcon(payerId);

  return <Popover
    content={
      <span className="card-tooltip-content">
        {disabled
          ? 'This card cannot be selected as the payer is not configured for this hospital'
          : 'Click on card to select'}
      </span>
    }
    placement="top"
  >
    <Card
      data-testid="benefCard"
      style={{ 'opacity': disabled ? '0.5' : '1' }}
      className={`scroll-policy policy-card policy-panel-styles
          ${isConfirmed ? 'policy-card-selected' : ''} card-selected mb-md`}
      hoverable={true}
    >
      <Col className="re-design-selected-Svg-Icon policy">
        {isConfirmed && <TickIcon />}
      </Col>
      <Row
        className="policy-card-header"
      />
      <Row className="policy-payer-logo">
        <img
          src={payerIconUrl}
          alt=""
        />
      </Row>
      <Row className="policy-card-content">
        <Col md={24}>
          <Row gutter={[0, 12]}>
            <Col md={8} className="policy-label">
              Payer Name: </Col>
            <Col md={16} className="policy-value bold">
              {payerName || '-'}
            </Col>
          </Row>
          <Row gutter={[0, 12]}>
            <Col md={8} className="policy-label">
              Member ID:
            </Col>
            <Col md={16} className="policy-value bold">
              {memberId || '-'}
            </Col>
          </Row>
          <Row gutter={[0, 12]}>
            <Col md={8} className="policy-label">
              Product Name:
            </Col>
            <Col md={16} className="policy-value his-doctor-value">
              {productName || '-'}
            </Col>
          </Row>
          <Row gutter={[0, 12]}>
            <Col md={8} className="policy-label">
              Product ID:
            </Col>
            <Col md={16} className="policy-value">
              {productId || '-'}
            </Col>
          </Row>
        </Col>
      </Row>

      <Row justify="end">
        <div className="spin-container">
          {
            isSelected && loading &&
            <Spin indicator={<LoadingOutlined className="card-loading-icon" spin={true} />} />
          }
        </div>
      </Row>
    </Card>
  </Popover>;
};

export default PolicyCard;
